// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"50"};